import firebase from "./firebase";

export const apiCache = {}

export const cacheRequest = async (route, init) => {
    const authHeader = init && init.headers && typeof init.headers.get === "function" ? init.headers.get("Authorization") : null;
    const cacheKey = `${route}::${authHeader || ""}`;
    if (apiCache[cacheKey]) {
        return apiCache[cacheKey]
    } else {
        let response = await fetch(route, init)
        let json = await response.json();
        apiCache[cacheKey] = json;
        return json;
    }
}

export const getAuthHeader = async () => {
    const currentUser = firebase.auth().currentUser
    if (currentUser) {
        const token = await currentUser.getIdToken()
        return new Headers({
            'Authorization': `Bearer ${token}`
        })
    }
    return null
}


